import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import {List, ListItem} from 'material-ui/List'

import { propertiesEx } from 'selectors/properties'

const statuses = {
	forRent: <img src={`/manager/static/img/property_statuses/for-rent.png`} alt="status" width="22"/>,
  outOfServ: <img src={`/manager/static/img/property_statuses/not-in-service.png`} alt="status" width="22"/>,
  occupied: <img src={`/manager/static/img/property_statuses/occupied-paid.png`} alt="status" width="22"/>,
  noPaid: <img src={`/manager/static/img/property_statuses/occupied-unpaid.png`} alt="status" width="22"/>,
  retired: <img src={`/manager/static/img/property_statuses/retired.png`} alt="retired" width="22"/>,
  underMaintenance: <img src={`/manager/static/img/property_statuses/under-maintenance.png`} alt="status" width="22"/>
}

let select = (state, props) => ({
	property: propertiesEx(state)[props.id]
})


export class PropertyStatusIcon extends Component{
	render(){
		return(
			(!this.props.property)?
			<div></div>
			:
			<div style={{height: "100%", float: "left", padding:"0 10px", position:"relative", top:"-2px"}}>
					{(this.props.property.dateTill)?statuses.retired
						:(this.props.property.status.forRent=='For Rent')?statuses.forRent:
						(this.props.property.status.occupied=='Occupied')?
						(this.props.property.status.paid)?statuses.occupied:statuses.noPaid
						:statuses.outOfServ}
			</div>
		)
	}
}
export default connect(select)(PropertyStatusIcon)



// WEBPACK FOOTER //
// ./src/routes/manager/properties/StatusIcon.js